import { render, staticRenderFns } from "./DialogConfirmation.vue?vue&type=template&id=90e1bf64&scoped=true"
import script from "./DialogConfirmation.js?vue&type=script&lang=js&external"
export * from "./DialogConfirmation.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e1bf64",
  null
  
)

export default component.exports